export const album = {
  songs: 'músicas',
  Album: 'Álbum',
  'More by': 'Mais de',
};
